import React from 'react';
import { CheckCircleIcon, RocketLaunchIcon, ShieldCheckIcon, WalletIcon, ChatBubbleLeftRightIcon, UserGroupIcon } from '@heroicons/react/24/solid';

const BenefitItem = ({ icon: Icon, title }) => {
    return (
        <div className="flex items-start space-x-3 md:space-x-4">
            <div className="flex-shrink-0">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center shadow-md">
                    <Icon className="h-4 w-4 md:h-5 md:w-5 text-white" />
                </div>
            </div>
            <p className="text-base md:text-lg text-gray-700 font-medium leading-relaxed flex-grow">
                {title}
            </p>
        </div>
    );
};

const BenefitsSection = () => {
    const benefitsData = [
        {
            icon: CheckCircleIcon,
            title: 'Improved patient care and outcomes',
        },
        {
            icon: RocketLaunchIcon,
            title: 'Enhanced operational efficiency',
        },
        {
            icon: UserGroupIcon,
            title: 'Reduced administrative burden',
        },
        {
            icon: ShieldCheckIcon,
            title: 'Better data security and compliance',
        },
        {
            icon: WalletIcon,
            title: 'Increased revenue through optimized billing',
        },
        {
            icon: ChatBubbleLeftRightIcon,
            title: 'Improved patient engagement and satisfaction',
        },
    ];

    return (
        <section className="pt-12 md:pt-16 lg:pt-18 pb-16 md:pb-20 lg:pb-28 bg-white">
            <div className="container mx-auto px-4 md:px-6 max-w-7xl">
                <div className="text-center mb-10 md:mb-14 lg:mb-16">
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-3 md:mb-4">
                        Unlock the <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500">Benefits</span>
                    </h2>
                    <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
                        Discover how our advanced healthcare platform transforms challenges into opportunities for growth and unparalleled patient care.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 md:gap-y-10 gap-x-6 md:gap-x-8 max-w-6xl mx-auto">
                    {benefitsData.map((benefit, index) => (
                        <BenefitItem
                            key={index}
                            icon={benefit.icon}
                            title={benefit.title}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BenefitsSection;